<div fxLayout="row">
  <div fxFlex="80" style="height: 150px">
    <abc-file-uploader
      #fileUploader
      [height]="'200px'"
      [invalidFileExtensionMessage]="res.get('InvalidFileType')"
      [labelText]="res.get('OrDragDrop')"
      [name]="'files[]'"
      [readyToUploadMessage]="res.get('ReadyForUpload')"
      [selectButtonText]="res.get('SelectFile')"
      [uploadMode]="'useForm'"
      [uploadUrl]="'/'"
      [validationStatus]="'valid'"
      [width]="'350px'"
      (onValueChanged)="onSelectedFileChanged($event)"
      [allowedFileExtensions]="['.zip', '.csv']"
    >
    </abc-file-uploader>
  </div>
</div>
